import {https , httpsFile} from './http.js';

export function index(page,currentpage,data) {
    return httpsFile().get(`/pr-draft?page=${page}&currentpage=${currentpage}&vendor_from=${data.vendor_from}&vendor_to=${data.vendor_to}&date_from=${data.date_from}&date_to=${data.date_to}&draft_number=${data.draft_number}&matnr=${data.materialno}`);
}

export function store(data) {
    return httpsFile().post('/pr-draft',data);
}

export function show(id) {
    return httpsFile().get(`/pr-draft/${id}`);
}

export function update(id,data){
    return httpsFile().post(`/pr-draft/${id}`,data);
}

export function destroy(id){
    return httpsFile().delete(`/pr-draft/${id}`);
}